import { useEffect, useState } from 'react';
import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

const INIT_STATE: AppStatusModal.HistoryView = {
    loading: false,
    pagination: {
        total: 0,
        pageSize: 5,
        current: 1,
        position: ['topRight', 'bottomRight'],
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15'],
    },
    history: []
};

export const useHistoryViewData = (applicationUuid: string, studentUuid: string) => {
    const [historyView, setHistoryView] = useState<AppStatusModal.HistoryView>({ ...INIT_STATE });
    const appsCategoryResult = useAppSelector((state) => state.appsCategoryResultConnection);

    useEffect(() => {
        const {
            meta: { status },
            payload: { result: payloadResult },
        } = appsCategoryResult;

        switch (status) {
            case Actions.statusEnum.REQUEST:
            case Actions.statusEnum.LOADING: {
                break;
            }
            case Actions.statusEnum.SUCCESS: {
                const total = payloadResult?.item_count ? payloadResult?.item_count : 0;
                const applications = payloadResult
                    ? payloadResult.items.find((item) => item.uuid === studentUuid)?.applications
                    : undefined;

                const application = applications
                    ? applications.find((item) => item.uuid === applicationUuid)
                    : undefined;

                const takes =
                    application &&
                    application.takes.filter((take) => {
                        return (
                            take.line_items.filter((lineItem) => lineItem?.score_line_items?.[0].timestamp).length !== 0
                        );
                    });

                const takesFilter = takes?.filter((item, index) => index !== 0);

                const history = takes?.map((item, index) => {
                    if (index === 0)
                        return {
                            title: '最新の結果',
                            take: item,
                        };
                    return {
                        title: '過去の結果',
                        take: item,
                        rowSpan: takesFilter?.length
                    };
                }) ?? [];

                setHistoryView({
                    ...historyView,
                    pagination: {
                        ...historyView.pagination,
                        total: total,
                    },
                    loading: false,
                    history: history,
                });
                break;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setHistoryView({ ...INIT_STATE });
                break;
            }
            default: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _: never = status;
            }
        }
        // appsCategoryResultのみ監視対象としたいため
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appsCategoryResult]);

    return [historyView] as const;
};
